import _ from 'underscore'
import resolve from 'ioc/resolve'
const $localStorage = resolve('$localStorage')

function hsvToHexRgb(h, s, v) {
    if (typeof h === 'object') {
        s = h.s;
        v = h.v;
        h = h.h;
    }

    var i = Math.floor(h * 6),
        f = h * 6 - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s);

    var r, g, b;

    switch (i % 6) {
        case 0:
            r = v;
            g = t;
            b = p;
            break;
        case 1:
            r = q;
            g = v;
            b = p;
            break;
        case 2:
            r = p;
            g = v;
            b = t;
            break;
        case 3:
            r = p;
            g = q;
            b = v;
            break;
        case 4:
            r = t;
            g = p;
            b = v;
            break;
        case 5:
            r = v;
            g = p;
            b = q;
            break;
    }

    r = Math.floor(r * 255) + 256;
    g = Math.floor(g * 255) + 256;
    b = Math.floor(b * 255) + 256;

    return '#'
        + r.toString(16).slice(1)
        + g.toString(16).slice(1)
        + b.toString(16).slice(1);
}

/**
 * Heavily based on:
 * http://stackoverflow.com/a/8023734/23501
 */
function hexRgbToHsv(hexRgb) {
    var tokens = /^#(..)(..)(..)$/.exec(hexRgb);

    if (tokens) {
        var rgb = tokens.slice(1).map(function (hex) {
            return parseInt(hex, 16) / 255; // Normalize to 1
        });

        var r = rgb[0],
            g = rgb[1],
            b = rgb[2],
            h, s,
            v = Math.max(r, g, b),
            diff = v - Math.min(r, g, b),
            diffc = function (c) {
                return (v - c) / 6 / diff + 1 / 2;
            };

        if (diff === 0) {
            h = s = 0;
        } else {
            s = diff / v;

            var rr = diffc(r),
                gg = diffc(g),
                bb = diffc(b);

            if (r === v) {
                h = bb - gg;
            } else if (g === v) {
                h = (1 / 3) + rr - bb;
            } else if (b === v) {
                h = (2 / 3) + gg - rr;
            }

            if (h < 0) {
                h += 1;
            } else if (h > 1) {
                h -= 1;
            }
        }

        return {
            h: h,
            s: s,
            v: v
        };
    }
}

const defaultPalette = ['rgb(255, 204, 204)',
    'rgb(255, 230, 204)',
    'rgb(255, 255, 204)',
    'rgb(204, 255, 204)',
    'rgb(204, 255, 230)',
    'rgb(204, 255, 255)',
    'rgb(204, 230, 255)',
    'rgb(204, 204, 255)',
    'rgb(230, 204, 255)',
    'rgb(255, 204, 255)',
    'rgb(255, 153, 153)',
    'rgb(255, 204, 153)',
    'rgb(255, 255, 153)',
    'rgb(153, 255, 153)',
    'rgb(153, 255, 204)',
    'rgb(153, 255, 255)',
    'rgb(153, 204, 255)',
    'rgb(153, 153, 255)',
    'rgb(204, 153, 255)',
    'rgb(255, 153, 255)',
    'rgb(255, 102, 102)',
    'rgb(255, 179, 102)',
    'rgb(255, 255, 102)',
    'rgb(102, 255, 102)',
    'rgb(102, 255, 179)',
    'rgb(102, 255, 255)',
    'rgb(102, 179, 255)',
    'rgb(102, 102, 255)',
    'rgb(179, 102, 255)',
    'rgb(255, 102, 255)',
    'rgb(255, 51, 51)',
    'rgb(255, 153, 51)',
    'rgb(255, 255, 51)',
    'rgb(51, 255, 51)',
    'rgb(51, 255, 153)',
    'rgb(51, 255, 255)',
    'rgb(51, 153, 255)',
    'rgb(51, 51, 255)',
    'rgb(153, 51, 255)',
    'rgb(255, 51, 255)',
    'rgb(255, 0, 0)',
    'rgb(255, 128, 0)',
    'rgb(255, 255, 0)',
    'rgb(0, 255, 0)',
    'rgb(0, 255, 128)',
    'rgb(0, 255, 255)',
    'rgb(0, 128, 255)',
    'rgb(0, 0, 255)',
    'rgb(128, 0, 255)',
    'rgb(255, 0, 255)',
    'rgb(245, 0, 0)',
    'rgb(245, 123, 0)',
    'rgb(245, 245, 0)',
    'rgb(0, 245, 0)',
    'rgb(0, 245, 123)',
    'rgb(0, 245, 245)',
    'rgb(0, 123, 245)',
    'rgb(0, 0, 245)',
    'rgb(123, 0, 245)',
    'rgb(245, 0, 245)',
    'rgb(214, 0, 0)',
    'rgb(214, 108, 0)',
    'rgb(214, 214, 0)',
    'rgb(0, 214, 0)',
    'rgb(0, 214, 108)',
    'rgb(0, 214, 214)',
    'rgb(0, 108, 214)',
    'rgb(0, 0, 214)',
    'rgb(108, 0, 214)',
    'rgb(214, 0, 214)',
    'rgb(163, 0, 0)',
    'rgb(163, 82, 0)',
    'rgb(163, 163, 0)',
    'rgb(0, 163, 0)',
    'rgb(0, 163, 82)',
    'rgb(0, 163, 163)',
    'rgb(0, 82, 163)',
    'rgb(0, 0, 163)',
    'rgb(82, 0, 163)',
    'rgb(163, 0, 163)',
    'rgb(92, 0, 0)',
    'rgb(92, 46, 0)',
    'rgb(92, 92, 0)',
    'rgb(0, 92, 0)',
    'rgb(0, 92, 46)',
    'rgb(0, 92, 92)',
    'rgb(0, 46, 92)',
    'rgb(0, 0, 92)',
    'rgb(46, 0, 92)',
    'rgb(92, 0, 92)',
    'rgb(255, 255, 255)',
    'rgb(205, 205, 205)',
    'rgb(178, 178, 178)',
    'rgb(153, 153, 153)',
    'rgb(127, 127, 127)',
    'rgb(102, 102, 102)',
    'rgb(76, 76, 76)',
    'rgb(51, 51, 51)',
    'rgb(25, 25, 25)',
    'rgb(0, 0, 0)'].map(rgbToHex);

const simplePalette = [
    { name: 'Color 1', hex: '#000000', rgb: 'rgb(0, 0, 0)' },
    { name: 'Color 2', hex: '#FFFFFF', rgb: 'rgb(255, 255, 255)' },
    { name: 'Color 15', hex: '#C0C0C0', rgb: 'rgb(192, 192, 192)' },
    { name: 'Color 48', hex: '#969696', rgb: 'rgb(150, 150, 150)' },
    { name: 'Color 16', hex: '#656565', rgb: 'rgb(100, 100, 100)' },
    { name: 'Color 56', hex: '#333333', rgb: 'rgb(51, 51, 51)' },
    { name: 'Color 3', hex: '#FF0000', rgb: 'rgb(255, 0, 0)' },
    { name: 'Color 4', hex: '#00FF00', rgb: 'rgb(0, 255, 0)' },
    { name: 'Color 5', hex: '#0000FF', rgb: 'rgb(0, 0, 255)' },
    { name: 'Color 6', hex: '#FFFF00', rgb: 'rgb(255, 255, 0)' },
    { name: 'Color 7', hex: '#FF00FF', rgb: 'rgb(255, 0, 255)' },
    { name: 'Color 19', hex: '#FFFFCC', rgb: 'rgb(255, 255, 204)' },
    { name: 'Color 36', hex: '#FFFF99', rgb: 'rgb(255, 255, 153)' },
    { name: 'Color 35', hex: '#CCFFCC', rgb: 'rgb(204, 255, 204)' },
    { name: 'Color 43', hex: '#99CC00', rgb: 'rgb(153, 204, 0)' },
    { name: 'Color 12', hex: '#808000', rgb: 'rgb(128, 128, 0)' },
    { name: 'Color 10', hex: '#008000', rgb: 'rgb(0, 128, 0)' },
    { name: 'Color 50', hex: '#339966', rgb: 'rgb(51, 153, 102)' },
    { name: 'Color 51', hex: '#003300', rgb: 'rgb(0, 51, 0)' },
    { name: 'Color 52', hex: '#333300', rgb: 'rgb(51, 51, 0)' },
    { name: 'Color 8', hex: '#00FFFF', rgb: 'rgb(0, 255, 255)' },
    { name: 'Color 42', hex: '#33CCCC', rgb: 'rgb(51, 204, 204)' },
    { name: 'Color 14', hex: '#008080', rgb: 'rgb(0, 128, 128)' },
    { name: 'Color 20', hex: '#CCFFFF', rgb: 'rgb(204, 255, 255)' },
    { name: 'Color 37', hex: '#99CCFF', rgb: 'rgb(153, 204, 255)' },
    { name: 'Color 33', hex: '#00CCFF', rgb: 'rgb(0, 204, 255)' },
    { name: 'Color 23', hex: '#0066CC', rgb: 'rgb(0, 102, 204)' },
    { name: 'Color 41', hex: '#3366FF', rgb: 'rgb(51, 102, 255)' },
    { name: 'Color 49', hex: '#003366', rgb: 'rgb(0, 51, 102)' },
    { name: 'Color 11', hex: '#000080', rgb: 'rgb(0, 0, 128)' },
    { name: 'Color 53', hex: '#993300', rgb: 'rgb(153, 51, 0)' },
    { name: 'Color 9', hex: '#800000', rgb: 'rgb(128, 0, 0)' },
    { name: 'Color 24', hex: '#CCCCFF', rgb: 'rgb(204, 204, 255)' },
    { name: 'Color 17', hex: '#9999FF', rgb: 'rgb(153, 153, 255)' },
    { name: 'Color 47', hex: '#666699', rgb: 'rgb(102, 102, 153)' },
    { name: 'Color 13', hex: '#800080', rgb: 'rgb(128, 0, 128)' },
    { name: 'Color 18', hex: '#993366', rgb: 'rgb(153, 51, 102)' },
    { name: 'Color 21', hex: '#660066', rgb: 'rgb(102, 0, 102)' },
    { name: 'Color 55', hex: '#333399', rgb: 'rgb(51, 51, 153)' },
    { name: 'Color 38', hex: '#FF99CC', rgb: 'rgb(255, 153, 204)' },
    { name: 'Color 22', hex: '#FF8080', rgb: 'rgb(255, 128, 128)' },
    { name: 'Color 39', hex: '#CC99FF', rgb: 'rgb(204, 153, 255)' },
    { name: 'Color 40', hex: '#FFCC99', rgb: 'rgb(255, 204, 153)' },
    { name: 'Color 44', hex: '#FFCC00', rgb: 'rgb(255, 204, 0)' },
    { name: 'Color 45', hex: '#FF9900', rgb: 'rgb(255, 153, 0)' },
    { name: 'Color 46', hex: '#FF6600', rgb: 'rgb(255, 102, 0)' },
    ];

function rgbToHex(arg) {
    var rgb = arg.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
}

function hex(x) {
    var val = parseInt(x).toString(16);
    switch (val.length) {
        case 1: return '0' + val;
        case 2: return val;
    }
    return '00;'
}

function format(_x) {
    let x = _x;
    if (_x && _x.colorStops)
        x = rgbToHex(_x.colorStops[0].color);
    if (/^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(x)) x = '#' + x; //hex
    return x;
}

function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

function colorStyle(color) {
    return color === 'rgba(0,0,0,0)' ? 'url(//emuncloud-staticassets.s3.amazonaws.com/transparent_swatch.gif)' : color;
}

function isDark(color) {
    var rgb = hexToRgb(color) || color || {};
    return (rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114) <= 186;
    //http://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
    var C = [rgb.r / 255, rgb.b / 255, rgb.b / 255];
    for (var i = 0; i < C.length; ++i) {
        if (C[i] <= 0.03928) {
            C[i] = C[i] / 12.92;
        } else {
            C[i] = Math.pow((C[i] + 0.055) / 1.055, 2.4);
        }
    }
    var L = 0.2126 * C[0] + 0.7152 * C[1] + 0.0722 * C[2];
    return (L <= 0.279);
}

if (!Array.isArray($localStorage.recentColors)) $localStorage.recentColors = [];

let webcolors = {
    defaultPalette,
    simplePalette,
    recent: $localStorage.recentColors,
    getRecent() {
        return webcolors.recent = $localStorage.recentColors;
    },
    addRecent(color, note) {
        if (!color) return;
        webcolors.recent = $localStorage.recentColors = _.chain([color].concat($localStorage.recentColors)).uniq().take(50).value();
    },
    clearRecent() {
        webcolors.recent = $localStorage.recentColors = [];
    },
    hex,
    format,
    isDark,
    isLight: c => !isDark(c),
    hexToRgb,
    hexRgbToHsv,
    hsvToHexRgb,
    rgbToHex
};

export default webcolors;